import { IconCircleI } from '@hawkins/assets';
import { Text, Tooltip } from '@hawkins/components';
import styles from './InputSectionHeader.module.css';

export const InputSectionHeader = ({
  headerText,
  tooltipText,
}: {
  headerText: string;
  tooltipText: string;
}) => (
  <div className={styles.inputSectionHeader}>
    <Tooltip label={tooltipText}>
      <IconCircleI size="small" />
    </Tooltip>
    <Text level={1} bold>
      {headerText}
    </Text>
  </div>
);
